import * as React from "react";
import { IScenarioState, OtherComponent } from "./Scenario";
import { ScenarioReferenceComponent } from "./ScenarioReference";
import { IDropTarget, Dnd, IDrop } from "./Dnd";
import { ICard } from "./Card";
import { DeckComponent } from "./DeckComponent";
import { MessageBus, IMessage } from "./Assert";

export interface IOtherComponentMenuItemProps {
    state: IScenarioState;
    onChanged: () => void;
    title: string;
    icon?:string;
    otherComponent: OtherComponent;
    index?: number;
}
export class OtherComponentMenuItemComponent extends React.Component<IOtherComponentMenuItemProps, any> implements IDropTarget {
    allowDrop(dragType: string, effectAllowed: string): string {
        switch (this.props.otherComponent) {
            case OtherComponent.EncounterDeck:
            case OtherComponent.DiscardPile:
            case OtherComponent.OutOfPlayCards:
            case OtherComponent.VictoryDisplay:
                if (/^card\/.+/.test(dragType)) {
                    return Dnd.move;
                }
                break;
        }
        return null;
    }
    onDrop(drop: IDrop): boolean {
        const card = drop.value as ICard;

        switch (this.props.otherComponent) {
            case OtherComponent.DiscardPile:
                if (!card) return false;
                if (!this.props.state.discardDeck)
                    this.props.state.discardDeck = { cards: [] };
                card.faceUp = true;
                card.tokens = [];
                this.props.state.discardDeck.cards.splice(0, 0, card);
                this.props.onChanged();
                return true;
            case OtherComponent.VictoryDisplay:
                if (!card) return false;
                if (!card.victoryPoints) return false;
                if (!this.props.state.victoryDisplay)
                    this.props.state.victoryDisplay = { cards: [] };
                card.faceUp = true;
                card.tokens = [];
                this.props.state.victoryDisplay.cards.splice(0, 0, card);
                this.props.onChanged();
                return true;
            case OtherComponent.OutOfPlayCards:
                if (!card) return false;
                const extraDeck = this.props.state.extraDecks[this.props.index];
                if (!extraDeck.cards)
                    extraDeck.cards = [];
                card.faceUp = true;
                card.tokens = [];
                extraDeck.cards.splice(0, 0, card);
                this.props.onChanged();
                return true;
            case OtherComponent.EncounterDeck:
                if (!card) return false;
                if (!this.props.state.encounterDeck.cards)
                    this.props.state.encounterDeck.cards = [];
                card.faceUp = false;
                card.tokens = [];
                this.props.state.encounterDeck.cards.push(card);
                this.props.onChanged();
                return true;
        }
        return false;
    }
    setActiveComponent() {
        this.props.state.activeOtherComponent = this.props.otherComponent;
        this.props.state.activeOtherComponentIndex = this.props.index;
        this.props.onChanged();
    }
    render() {
        let className = "";
        let activeState = this.props.state.activeOtherComponent;
        if (!activeState) activeState = OtherComponent.ScenarioReference;
        //active is same state and same index (if oop cards)
        if (activeState === this.props.otherComponent && (activeState !== OtherComponent.OutOfPlayCards || this.props.state.activeOtherComponentIndex === this.props.index)) {
            className = "active";
        }
        return (<li className={className}
            onClick={() => { this.setActiveComponent(); }}
            onDragOver={(e) => Dnd.dragOver(e, this)}
            onDrop={(e) => Dnd.drop(e, this)}
        >{this.props.icon ? <i className={this.props.icon} title={this.props.title}></i>:this.props.title}</li>);
    }

}
export interface IOtherComponentSelectorProps {
    state: IScenarioState;
    onChanged: () => void;
}
export class OtherComponentSelectorComponent extends React.Component<IOtherComponentSelectorProps, any> {
    public static readonly messageZoomEncounterCard = "ZoomEncounterCard";
    encounterDeck: DeckComponent;
    msgHandler: (msg: IMessage) => void;
    drawAnEncounterCard(): boolean {
        const ss = this.props.state;
        if (ss.activeOtherComponent !== OtherComponent.EncounterDeck) {
            ss.activeOtherComponent = OtherComponent.EncounterDeck;
            this.props.onChanged();
            MessageBus.trigger(OtherComponentSelectorComponent.messageZoomEncounterCard);
            return false;
        }
        this.encounterDeck.flipAndZoomTopCard();
        return true;
    }
    componentWillMount(): void {
        this.msgHandler = (message) => {
            switch (message.name) {
                case OtherComponentSelectorComponent.messageZoomEncounterCard:
                    this.drawAnEncounterCard();
                default:
                    return;
            }
        };
        MessageBus.connect(this.msgHandler);
    }

    componentWillUnmount(): void {
        MessageBus.disconnect(this.msgHandler);
    }

    render() {
        const ss = this.props.state;
        let cc = ss.activeOtherComponent;
        if (!cc) cc = OtherComponent.ScenarioReference;
        let component: JSX.Element = null;
        switch (cc) {
            case OtherComponent.ScenarioReference:
                component = (<ScenarioReferenceComponent key={cc} card={ss.scenarioCard} difficulty={ss.difficulty} />);
                break;
            case OtherComponent.EncounterDeck:
                component = (<DeckComponent key={cc} deck={ss.encounterDeck} onChanged={() => this.props.onChanged()}
                    settings={{ toolbar: { shuffle: true, navigation: true, edit: true }, draggable: true }}
                    ref={(ref) => { this.encounterDeck = ref; }}
                />);
                break;
            case OtherComponent.DiscardPile:
                component = (<DeckComponent key={cc} deck={ss.discardDeck} onChanged={() => this.props.onChanged()}
                    settings={{ toolbar: { navigation: true }, draggable: true }} />);
                break;
            case OtherComponent.VictoryDisplay:
                component = (<DeckComponent key={cc} deck={ss.victoryDisplay} onChanged={() => this.props.onChanged()}
                                            settings={{ toolbar: { navigation: true }, draggable: true }} />);
                break;
            case OtherComponent.OutOfPlayCards:
                const deck = ss.extraDecks[ss.activeOtherComponentIndex];
                component = (<DeckComponent key={cc} deck={deck} onChanged={() => this.props.onChanged()}
                    settings={{ toolbar: { navigation: true, addCard: true, removeTopCardFromPlay: true }, draggable: true }} />);
                break;
        }

        let extraDeckMenuItems: JSX.Element[] = null;
        if (ss.extraDecks) {
            extraDeckMenuItems = ss.extraDecks.map((d, i) => {
                return (<OtherComponentMenuItemComponent key={i} title={d.name} icon={d.icon}
                    otherComponent={OtherComponent.OutOfPlayCards} index={i} state={ss}
                    onChanged={() => this.props.onChanged()} />
                );
            });
        }
        return (
            <div id="otherComponentSelector">
                <div>
                    <ul className="active-selector">
                        <OtherComponentMenuItemComponent title="Reference Card" icon="fas fa-ankh" otherComponent={OtherComponent.ScenarioReference} state={ss} onChanged={() => this.props.onChanged()} />
                        <OtherComponentMenuItemComponent title="Encounter Deck" icon="fas fa-chess-rook" otherComponent={OtherComponent.EncounterDeck} state={ss} onChanged={() => this.props.onChanged()} />
                        {extraDeckMenuItems}
                        <OtherComponentMenuItemComponent title="Discard Deck" icon="fas fa-trash" otherComponent={OtherComponent.DiscardPile} state={ss} onChanged={() => this.props.onChanged()} />
                        <OtherComponentMenuItemComponent title="Victory Display" icon="fas fa-crown" otherComponent={OtherComponent.VictoryDisplay} state={ss} onChanged={() => this.props.onChanged()} />
                    </ul>
                </div>
                <div>
                    {component}
                </div>
            </div>
        );
    }
}
